import { Sport } from './sport';

export class MapEventEntity {
    public code: string = null;
    public title: string = '';
    public organizer: string = '';
    public startDate: string = null;
    public endDate: string = null;
    public latitude: number = null;
    public longitude: number = null;
    public sport: Sport = Sport.NotSet;

    public static fromDto(dto: any): MapEventEntity {
        if (!dto) return new MapEventEntity();
        const entity = new MapEventEntity();
        entity.code = dto.code;
        entity.title = dto.title;
        entity.organizer = dto.organizer;
        entity.startDate = dto.startDate;
        entity.endDate = dto.endDate;
        entity.latitude = dto.latitude;
        entity.longitude = dto.longitude;
        entity.sport = dto.sport ?? Sport.NotSet;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): MapEventEntity[] {
        if (!dtoArray) return [];
        return dtoArray.map(dto => MapEventEntity.fromDto(dto));
    }
}
